import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Register from './pages/Register';
import Feed from './pages/Feed';
import Activities from './pages/Activities';
import Groups from './pages/Groups';
import ConnectCalendar from './pages/ConnectCalendar';
import CreateActivity from './pages/CreateActivity';
import ActivityDetail from './pages/ActivityDetail';
import Profile from './pages/Profile';
import GroupDetail from './pages/GroupDetail';
import CreateGroup from './pages/CreateGroup';
import FindFriends from './pages/FindFriends';
import Friends from './pages/Friends';
import EditActivity from './pages/EditActivity';
import Calendar from './pages/Calendar';
import CloseCircle from './pages/CloseCircle';
import JoinActivity from './pages/JoinActivity';
import JoinGroup from './pages/JoinGroup';
import Discover from './pages/Discover';
import Onboarding from './pages/Onboarding';
import Notifications from './pages/Notifications';
import Messages from './pages/Messages';
import Landing from './pages/Landing';
import ActivityPreview from './pages/ActivityPreview';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import VerifyEmail from './pages/VerifyEmail';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import UserProfile from './pages/UserProfile';
import ProtectedRoute from './components/ProtectedRoute';
import './styles/index.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/join/:token" element={<JoinActivity />} />
        <Route path="/join/group/:token" element={<JoinGroup />} />

        <Route path="/feed" element={<ProtectedRoute><Feed /></ProtectedRoute>} />
        <Route path="/activities" element={<ProtectedRoute><Activities /></ProtectedRoute>} />
        <Route path="/groups" element={<ProtectedRoute><Groups /></ProtectedRoute>} />
        <Route path="/calendar-settings" element={<ProtectedRoute><ConnectCalendar /></ProtectedRoute>} />
        <Route path="/create-activity" element={<ProtectedRoute><CreateActivity /></ProtectedRoute>} />
        <Route path="/activity/:id" element={<ProtectedRoute><ActivityDetail /></ProtectedRoute>} />
        <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
        <Route path="/profile/:userId" element={<ProtectedRoute><UserProfile /></ProtectedRoute>} />
        <Route path="/group/:id" element={<ProtectedRoute><GroupDetail /></ProtectedRoute>} />
        <Route path="/create-group" element={<ProtectedRoute><CreateGroup /></ProtectedRoute>} />
        <Route path="/find-friends" element={<ProtectedRoute><FindFriends /></ProtectedRoute>} />
        <Route path="/friends" element={<ProtectedRoute><Friends /></ProtectedRoute>} />
        <Route path="/activity/:id/edit" element={<ProtectedRoute><EditActivity /></ProtectedRoute>} />
        <Route path="/calendar" element={<ProtectedRoute><Calendar /></ProtectedRoute>} />
        <Route path="/close-circle" element={<ProtectedRoute><CloseCircle /></ProtectedRoute>} />
        <Route path="/discover" element={<Discover />} />
        <Route path="/activity/:id/preview" element={<ActivityPreview />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/notifications" element={<ProtectedRoute><Notifications /></ProtectedRoute>} />
        <Route path="/messages" element={<ProtectedRoute><Messages /></ProtectedRoute>} />
        <Route path="/messages/:userId" element={<ProtectedRoute><Messages /></ProtectedRoute>} />
        <Route path="/onboarding" element={<ProtectedRoute><Onboarding /></ProtectedRoute>} />

        <Route path="/" element={
          localStorage.getItem('token') ? <Navigate to="/feed" /> : <Landing />
        } />
      </Routes>
    </Router>
  );
}

export default App;
